import React from 'react';
import PrimaryActionsButton from '../../resource-card/primary-actions-button';

interface DevBoxCardFooterProps {
    arePrimaryActionsDisabled?: boolean;
    primaryActions: JSX.Element[];
    headlessActions?: JSX.Element[];
}

export const DevBoxCardActions: React.FC<DevBoxCardFooterProps> = React.memo((props: DevBoxCardFooterProps) => {
    const { primaryActions, headlessActions, arePrimaryActionsDisabled } = props;

    const showPrimaryActionsButton = primaryActions && primaryActions.length > 0;

    return showPrimaryActionsButton ? (
        <PrimaryActionsButton
            primaryActions={primaryActions}
            headlessActions={headlessActions}
            disabled={arePrimaryActionsDisabled}
        />
    ) : (
        <></>
    );
});
